module.exports = __webpack_public_path__ + "static/media/test16_4.03c366ed.png";